import { useNavigate } from "react-router-dom";
import "../styles/general.css";
import "../styles/noticias.css"

const Noticias: React.FC = () => {

    const navigate = useNavigate();

  return (
    <div className="modal-container">
      <div className="section_1">
        <div>
          <div>
            <h5>Bienvenido a la dApp de Mox Holkan</h5>
            <h2>Aprende, juega, gana y participa en nuestra economía Web3.</h2>

            <div className="button welcome-container">
              <button
                className="btn-primary"
                onClick={() =>
                  window.open("http://app.moxholkan.com/referido", "_self")
                }
              >
                🎁 Reclamar Regalo
              </button>
              <p>Si ya tienes tu Wallet. Recibe 50 UMQ de Bienvenida</p>
              <button
                className="btn-secondary"
                onClick={() =>
                  window.open("https://t.me/TemasiliMoxHolkan", "_self")
                }
              >
                📢 Únete a Telegram
              </button>
              <p>Entérate de novedades en nuestra comunidad de Telegram</p>
            </div>
          </div>
        </div>
      </div>

      <div className="section section_2">
        <div className="service-grid">
          <div className="service-box">
            <h3>🛍️ Moxplace</h3>
            <p>Compra productos usando tus UMQ. Próximamente HLK y GUX.</p>
          </div>
          <div className="service-box">
            <h3>🎰 Mox Juegos</h3>
            <p>Juega gana UMQ, con cada oportnidad ganas.</p>
            <p>Próximamente más juegos</p>
          </div>
          <div className="service-box">
            <h3>📈 Mox Stake</h3>
            <p>Guarda tus UMQ; gana HLK o GUX como recompensa.</p>
            <p>Próximamente fechas del primer stake</p>
          </div>
          <div className="service-box">
            <h3>🧠 Mox Quiz</h3>
            <p>
              Responde preguntas y gana UMQ mientras aprendes sobre blockchain,
              agro y otros temas de interés.
            </p>
          </div>
          <div className="service-box">
            <h3>🎁 Regalo</h3>
            <p>
              Recibe 50 UMQ de bienvenida al conectar tu wallet por primera vez.
            </p>
          </div>
        </div>
      </div>
      <div className="section section_3">
         <p>No olvides visitar periodicamente esta seccion de NOTICIAS para estar al tanto del proyecto y siguenos en nuestras redes sociales</p>
         <button className="button-exit mt-4" onClick={() => navigate("/home")}>Volver</button>
        <h3>
          <a
            href="https://moxholkan.com"
            target="_self"
            rel="noopener noreferrer"
            className="custom-link"
          >
            Inicio
          </a>
        </h3>
      </div>
    </div>
  );
};

export default Noticias;
